import { useMemo } from 'react';

import useColors from '@ee-api/colors-api/useColors';
import useMaterials from '@ee-api/materials-api/useMaterials';
import { useStores } from '@ee-api/stores-api/useStores';

type UseParentFetchStatusResult = {
    isFetchingDependencies: boolean;
};

/**
 * are all the primary dependencies for API requests (zipcode, store, material) done fetching?
 */
export const useFetchDependencies = (): UseParentFetchStatusResult => {
    const { isFetchingStores } = useStores();
    const { isFetchingMaterials } = useMaterials();
    const { isFetchingColors } = useColors();

    const isFetchingDependencies = useMemo(
        () => isFetchingStores || isFetchingMaterials || isFetchingColors,
        [isFetchingColors, isFetchingMaterials, isFetchingStores]
    );

    return {
        isFetchingDependencies,
    };
};
